/* unplugin-vue-components disabled */import script from "./RolePropsEditCard.vue?vue&type=script&setup=true&lang=js"
export * from "./RolePropsEditCard.vue?vue&type=script&setup=true&lang=js"

import "./RolePropsEditCard.vue?vue&type=style&index=0&id=1bff8824&scoped=true&lang=less"

import exportComponent from "/Users/zhangxuan/Documents/Projects/VinesDjango/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1bff8824"]])

export default __exports__